import axios from "axios";
import React, { useEffect, useState } from "react";
import * as Constants from "../constants/urls";
import { useCookies } from "react-cookie";
import moment from "moment-jalaali";

import Pagination from "react-js-pagination";
const CustomTable = ({
    columns,
    rows,
    apiUrl
}) => {
    const [data, setDate] = useState(undefined);
    const [cookies, setCookie, removeCookie] = useCookies();
    const [filters, setFilters] = useState([

    ]);

    function getData(page) {
        let filterUrl = "";
        filters.map((item) => {
            if (item.value != null)
                filterUrl += `filter[${item.key}]=${item.value}&`
        })
        const url = Constants.apiUrl + apiUrl + "?" + filterUrl;
        axios
            .post(
                url,
                { page: page },
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((r) => {
                setDate(r.data);
            })
            .catch((e) => {
                console.log("ERROR IS ", e);
            });
    }
    useEffect(() => {
        let filterArray = [];
        columns.map((item) => {
            filterArray.push({
                key: item.name,
                value: null
            })
        })
        setFilters(filterArray);

    }, []);
    useEffect(() => {
        getData(1);
    }, []);

    useEffect(() => {
        getData(1);
    }, [filters]);

    function filter(e) {
        let key = e.target.name;
        let value = e.target.value;

        const newFilter = filters.map(obj => {
            if (obj.key == key) {
                return { ...obj, value: value };
            }
            return obj;
        });
        setFilters(newFilter)
        getData(1, filters);
    }
    function jsonValue(row, keys) {
        let array = keys.split('.');
        for (var i = 0; i < array.length; i++) {
            row = row[array[i]];
            if (array[i] == "time")
                return moment(row * 1000).format('jYYYY/jM/jD H:m:s');
        }
        return row;
    }


    return (
        <React.Fragment>
            <div className="container-fluid">
                <table className="table table-hover ">
                    <thead className="">
                        <tr className="bg-danger text-white">
                            {
                                columns.map((item) => (<th scope="col">{item.title}</th>))
                            }

                        </tr>
                        <tr className="bg-danger text-white">
                            {
                                columns.map((item) => (<th scope="col">
                                    {
                                        item.filters ? (<select  name={item.name} onChange={filter} className="text-black">
                                            <option value={""}> همه</option>
                                            {
                                                item.filters.map((filterItem)=>(<option value={filterItem.value}>
                                                    {filterItem.title}
                                                </option>))
                                            }
                                        </select>
                                        ) :
                                            <input name={item.name} onChange={filter} className="text-black" />

                                    }
                                </th>))
                            }

                        </tr>

                    </thead>
                    <tbody>
                        {data &&
                            data.data &&
                            data.data.map((item, index) => {
                                return (
                                    <tr>
                                        {
                                            rows.map((row) => (<th scope="row">{jsonValue(item, row)}</th>))
                                        }

                                    </tr>
                                );
                            })}
                    </tbody>
                </table>

                <div className="pager Page navigation example">
                    {data && (
                        <Pagination
                            totalItemsCount={data.total}
                            activePage={data.current_page}
                            itemsCountPerPage={data.per_page}
                            onChange={(number) => {
                                getData(number);
                            }}
                            itemClass="page-item"
                            linkClass="page-link"
                            firstPageText="اولین صفحه"
                            lastPageText="آخرین صفحه"
                            nextPageText="بعدی"
                            prevPageText="قبلی"
                            activeClass="pageactive"
                        />
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};
export default CustomTable;
